<template>
  <div>
    <el-container>
      <el-header class="other-list-header">
        <div style="text-align:center;">
          <span>查询条件：</span>
          <el-input
            style="width:45%; margin:20px auto;"
            placeholder="请输入关键字"
            v-model="searchText"
            size="mini"
          ></el-input>
          <el-button type="primary" size="mini" @click="listSearch()">查询</el-button>
          <el-button v-if="false" size="mini" @click="listAdd()">新增</el-button>
        </div>
      </el-header>
      <el-container>
        <el-main class="other-list-main" style="height:100%">
          <el-table :data="listData.list" border style="width: 100%">
            <el-table-column label="排序号" width="70">
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px"
                >{{ scope.$index+1+(listData.pageIndex-1)*listData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.userName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="身份证">
              <template slot-scope="scope">
                <span>{{ scope.row.idCardNumber }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公司">
              <template slot-scope="scope">
                <span>{{ scope.row.companyName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" v-if="false">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    v-if="category==='0'"
                    type="info"
                    @click="toChange(scope.row)"
                  >转黑名单</el-button>
                  <el-button
                    size="mini"
                    v-if="category==='1'"
                    type="primary"
                    @click="toChange(scope.row)"
                  >转白名单</el-button>
                  <el-button size="mini" type="danger" @click="listDelete(scope.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <div class="other-list-page">
            <el-pagination
              background
              layout="prev, pager, next"
              small="true"
              :page-size="listData.pageSize"
              :page-count="listData.totalPageCount"
              :total="listData.totalCount"
              :current-page.sync="listData.pageIndex"
              @current-change="listSearch()"
            ></el-pagination>
          </div>
          <el-dialog title="编辑" :visible.sync="formVisible" width="40%" :before-close="formClose">
            <el-dialog
              class="dialog-append"
              width="30%"
              title="是否关联当前用户"
              :visible.sync="innerVisible"
              append-to-body
            >
              <table>
                <tr>
                  <td>姓名:</td>
                  <td>{{selUser.name}}</td>
                </tr>
              </table>
              <br />
              <el-button type="primary" size="mini" @click="formSubmit(1)">关联</el-button>
              <el-button size="mini" @click="formSubmit(2)">不关联</el-button>
              <el-button size="mini" @click="formSubmit(3)">取消</el-button>
              <div style="width:20px"></div>
            </el-dialog>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
              <el-form-item label="姓名" prop="userName">
                <el-input type="text" size="mini" v-model="ruleForm.userName"></el-input>
              </el-form-item>
              <el-form-item label="身份证" prop="idCardNumber">
                <el-input type="text" size="mini" v-model="ruleForm.idCardNumber"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" @click="formSubmit(0)">提 交</el-button>
                <el-button size="mini" @click="formClose()">取 消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import publish_ from "@/components/publish"; //引用模块进来
import {
  getCompanyVisitorList,
  delVisitorList,
  addVisitorType,
  isExistUserInfo
} from "@/api/api";

export default {
  data() {
    return {
      user: {},
      selUser: {},
      listData: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10,
        totalPageCount: 1,
        list: []
      }, //列表集合数据
      searchText: "", //查询内容
      formVisible: false, //是否显示新增
      innerVisible: false, //框中框
      ruleForm: {}, //表单绑定数据变量
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "change" }
        ],
        idCardNumber: [
          { required: true, message: "请输入身份证", trigger: "change" }
        ]
      } //表单数据验证
    };
  },
  props: {
    category: {
      type: Number,
      default: 0
    } //0白名单，1黑名称
  },
  //初始化数据
  mounted() {
    this.user = JSON.parse(window.localStorage.user);
    this.formReset();
    this.getListData();
  },
  methods: {
    //表单初始化
    formReset() {
      //表单初始值模板
      this.ruleForm = {
        userName: "",
        idCardNumber: ""
      };
    },
    //查询列表
    getListData() {
      var _this = this;
      var para = {
        params: {
          companyId: this.user.companyId,
          category: this.category,
          condition: this.searchText,
          pageIndex: 1,
          pageSize: 10
        }
      };

      getCompanyVisitorList(para).then(res => {
        if (res.data.success) {
          _this.listData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //点击查询
    listSearch() {
      this.getListData();
    },
    //点击新增
    listAdd() {
      this.formVisible = true;
      this.formReset();
    },
    //list点击删除
    listDelete(row) {
      var para = {
        params: { visitorId: row.id }
      };
      delVisitorList(para).then(res => {
        if (publish_.isEmt(res)) {
          this.formVisible = false;
          return;
        }
        if (res.data.success) {
          this.$message.success("删除成功");
          this.getListData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //表单提交(type:0提交查询用户和身份证，1提交用户和身份证做关联，2提交用户和身份证不做关联，3隐藏框内框)
    formSubmit(type) {
      var _this = this;
      if (type === 0) {
        var para = {
          params: {
            userName: this.ruleForm.userName,
            idCardNumber: this.ruleForm.idCardNumber
          }
        };
        isExistUserInfo(para).then(res => {
          if (res.data.success) {
            if (res.data.data.id > 0) {
              _this.selUser = res.data.data;
              _this.innerVisible = true;
            } else {
              this.formSubmit(2);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (type === 3) {
        this.innerVisible = false;
      } else {
        //提交表单
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.ruleForm.category = parseInt(this.category);
            this.ruleForm.companyId = this.user.companyId;
            if (type === 1) {
              this.ruleForm.userId = this.selUser.userId;
            }
            addVisitorType(this.ruleForm).then(res => {
              if (publish_.isEmt(res)) {
                _this.formVisible = false;
                _this.innerVisible = false;
                return;
              }
              if (res.data.success) {
                _this.$message.success("提交成功");
                _this.getListData();
                _this.formVisible = false;
                _this.innerVisible = false;
              } else {
                _this.$message.error(res.data.msg);
              }
            });
          } else {
            alert("提交失败!");
            return false;
          }
        });
      }
    },
    //在表单提交页面，点击空白处
    formClose() {
      this.$confirm("确认关闭？")
        .then(_ => {
          this.formVisible = false;
        })
        .catch(_ => {});
    },
    toChange(model) {
      this.formReset();
      this.ruleForm.id = model.id;
      this.ruleForm.userName = model.userName;
      this.ruleForm.idCardNumber = model.idCardNumber;
      this.ruleForm.companyId = this.user.companyId;
      if (this.category === "0") {
        this.ruleForm.category = 1;
      } else {
        this.ruleForm.category = 0;
      }
      this.ruleForm.userId = this.selUser.userId;
      var _this = this;
      addVisitorType(this.ruleForm).then(res => {
        if (res.data.success) {
          _this.$message.success("转换成功");
          _this.getListData();
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>

<style>
.dialog-append .el-dialog__body {
  padding: 5px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/fksys/hbmd/black.vue